import { Link } from "@tanstack/react-router";
import { MessageSquare, Phone } from "lucide-react";

import { FIRM } from "@/lib/firm";

/**
 * Fixed bottom action bar on small screens so the phone number and enquiry
 * form are always one tap away, no matter how far down a long page you are.
 */
export function MobileCallBar() {
  return (
    <div className="fixed inset-x-0 bottom-0 z-40 border-t border-border bg-background/95 backdrop-blur lg:hidden">
      <div className="grid grid-cols-2 gap-2 px-3 py-2.5">
        <a
          href={FIRM.phoneHref}
          className="inline-flex items-center justify-center gap-2 rounded-sm bg-primary px-4 py-3 text-sm font-semibold text-primary-foreground"
        >
          <Phone className="size-4 shrink-0" aria-hidden="true" />
          Call us
        </a>
        <Link
          to="/contact"
          className="inline-flex items-center justify-center gap-2 rounded-sm bg-accent px-4 py-3 text-sm font-semibold text-accent-foreground"
        >
          <MessageSquare className="size-4 shrink-0" aria-hidden="true" />
          Get a quote
        </Link>
      </div>
    </div>
  );
}
